import React, { Fragment } from "react";

import SideNav from "components/common/wrapper/section/side-nav/SideNav";
import NavBar from "components/common/wrapper/section/nav-bar/NavBar.tsx";
import Main from "components/common/wrapper/section/Main";
import DrawersContainer from "components/common/drawers-container/DrawersContainer";

export default ({ isOpenSideNav, toggleSideNav, children }) => (
  <Fragment>
    <SideNav isOpen={isOpenSideNav} />
    <Main isOpen={isOpenSideNav}>{children}</Main>
    <NavBar toggleSideNav={toggleSideNav} />
    <DrawersContainer />
  </Fragment>
);
